import { environment } from '../../../environments/environment'

export const BASE_URL = environment.API_BASE
export class ApiConfig {
  public static baseURL = environment.API_BASE
  public static authURL = `${environment.API_BASE}/auth/login`
}
